import { Image } from '@silvertours/back-domain-page';

import { StyledImage } from './GuideStage.styles';

const GuideStage = ({ image: { src, width, height } }: { image: Image }) => (
  <StyledImage
    src={src}
    alt=""
    width={width}
    height={height}
    priority
    sizes="(max-width: 1200px) 100vw, 1200px"
  />
);

export { GuideStage };
